"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UniversalTokenProvider = void 0;
var _tokenContext = require("./tokenContext");
var _useUniversalToken = require("./useUniversalToken");
var _jsxRuntime = require("react/jsx-runtime");
const UniversalTokenProvider = ({
  children,
  customerId,
  initialToken
}) => {
  const contextValue = (0, _useUniversalToken.useUniversalToken)({
    customerId,
    initialToken
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tokenContext.tokenContext.Provider, {
    value: contextValue,
    children: children
  });
};
exports.UniversalTokenProvider = UniversalTokenProvider;
//# sourceMappingURL=UniversalTokenProvider.js.map